import { render, staticRenderFns } from "./SurveyResults.vue?vue&type=template&id=33deb766&scoped=true"
import script from "./SurveyResults.vue?vue&type=script&lang=js"
export * from "./SurveyResults.vue?vue&type=script&lang=js"
import style0 from "./SurveyResults.vue?vue&type=style&index=0&id=33deb766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33deb766",
  null
  
)

export default component.exports